import http from '../../../../config/BaseUrl'
import { pastEventItemList, pastEventLoading } from './pastEventSlice'

export const pastEventList = (params) => async (dispatch) => {
    try{
        dispatch(pastEventLoading())
        await http.get(`past-event${params}`)
        .then((res) => {
           dispatch(pastEventItemList(res.data.event))
        }).catch((err) => {
            console.log(err.response.data.message);
        })
    }catch(error){

    }
}